import { cn } from "@/lib/utils";

interface LogoProps {
  /** dimensione in px del logo (quadrato per il mark, larghezza per il hero) */
  size?: number;
  /** se true mostra l'hero rettangolare con figura + wordmark integrato */
  hero?: boolean;
  /** rounded corners on the box (default true for mark) */
  rounded?: boolean;
  className?: string;
}

/**
 * Logo brand Machiavelli.
 *
 * - default: logo-mark.png (monogramma quadrato, ritagliato dal hero)
 *   usato in Sidebar, Topbar mobile, BottomNav
 * - hero=true: logo.png (immagine completa 16:9 con figura + wordmark)
 *   usato nella pagina Login
 *
 * File: apps/web/public/logo.png e logo-mark.png
 */
export function Logo({ size = 40, hero = false, rounded = true, className }: LogoProps) {
  if (hero) {
    return (
      <img
        src="/logo.png"
        alt="Machiavelli"
        className={cn(
          "block h-auto select-none",
          rounded && "rounded-2xl shadow-renaissance",
          className,
        )}
        style={{ width: size }}
      />
    );
  }

  return (
    <img
      src="/logo-mark.png"
      alt="Machiavelli"
      className={cn(
        "block shrink-0 select-none object-cover",
        rounded && "rounded-xl shadow-renaissance ring-1 ring-primary/15",
        className,
      )}
      style={{ width: size, height: size }}
    />
  );
}
